<template>
    <div class="submit-spc-order">
        <el-form ref="form" label-width="100px" label-position="left">
            <div class="form-title"><svg-icon icon-class="lm" class-name="lm-icon" />工程信息</div>
            <div style="font-size: 14px; color: #000000" v-if="!orders_id">{{ orderInfo.Orders.Orders_ProjectAddress }}</div>
            <div style="font-size: 14px; color: #000000" v-else>{{ submitCustomerInfor.Orders_ProjectAddress }}</div>
            <div class="mt10" v-if="orderInfo.Orders.Orders_ProjectCounty==''">
                <el-select v-model="params.Customer_Project_Country" placeholder="请选择国家" class="el-select-medium" @change="countryChange(1, $event)" clearable filterable>
                    <el-option v-for="item in countryList" :key="item.Country_Code" :label="item.Country_CN" :value="item.Country_Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_State" placeholder="省/直辖市" @change="provinceChange" clearable filterable>
                    <el-option v-for="item in provinceList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_City" placeholder="市" @change="cityChange" clearable filterable>
                    <el-option v-for="item in cityListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_County" placeholder="区/县" clearable filterable>
                    <el-option v-for="item in districtListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <font style="color: #ff0000; margin-left: 5px">*</font>
            </div>

            <div class="form-title"><svg-icon icon-class="lm" class-name="lm-icon" />合同联系人</div>
            <el-form-item label="联系人姓名">
                <el-input class="el-select-big" autocomplete="on" v-model="params.Orders_Contract_Name">
                    <el-button slot="append" icon="el-icon-search" @click="searchUser"></el-button>
                </el-input>
                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <el-form-item label="联系人手机">
                <el-input class="el-select-big" autocomplete="on" v-model="params.Orders_Contract_Mobile"></el-input>
                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <el-form-item label="联系人邮箱">
                <el-input class="el-select-big" autocomplete="on" v-model="params.Orders_Contract_Email"></el-input>
                <font style="color: #ff0000; margin-left: 5px">*</font>
            </el-form-item>
            <div v-if="params.Show_CreditInvoiceStatus">
                <div class="form-title"><svg-icon icon-class="lm" class-name="lm-icon" />是否开具红冲发票</div>
                
                    <el-checkbox :label="1" class="fw700" v-model="params.Orders_CreditInvoiceStatus"><span style="color: red">开具红冲发票</span></el-checkbox>
                
            </div>
            <div class="form-title"><svg-icon icon-class="lm" class-name="lm-icon" />退货清单</div>
            
                <el-checkbox :label="1" v-model="params.Orders_ReturnCommitment"><span class="fw700"  style="color: red">退货承诺：本次退货设备已核验完毕，不影响二次销售</span></el-checkbox>
            
            <el-table :data="submitReturnsList.filter((item) => item.Goods_Product_Amount != 0)" style="width: 100%; margin-top: 10px" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                <el-table-column prop="Goods_SaleGroupName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                <el-table-column prop="Goods_Product_Code" label="商品编码" align="center" width="100"></el-table-column>
                <el-table-column prop="Goods_Product_Name" label="商品名称" align="left"></el-table-column>
                <el-table-column prop="Product_Spc" label="规格" align="center" width="100"></el-table-column>
                <el-table-column prop="" label="已下架" align="center" width="80">
                    <template v-slot="scope">
                        <span>{{ scope.row.Product_IsInsale == 0 ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Goods_Product_SourcePrice" label="单价" align="center" width="100">
                    <template v-slot="scope">
                        <span class="is-status-text">￥{{ getFloat(scope.row.Goods_Product_SourcePrice, 2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Deliver_Amount" label="总数" align="center" width="100"></el-table-column width="80">
                <el-table-column prop="" label="合计" align="center" width="100">
                    <template v-slot="scope">
                        <span class="is-status-text">{{ getFloat(scope.row.Deliver_Amount * scope.row.Goods_Product_SourcePrice, 2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ReturnQuantity" label="可退货数量" align="center" width="100"></el-table-column>
                <el-table-column prop="Goods_Product_Price" label="退货单价" align="center" width="100">
                    <template v-slot="scope">
                        <span class="is-status-text">￥{{ getFloat(scope.row.Goods_Product_Price, 2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Goods_Product_Amount" label="退货数量" align="center" width="100"></el-table-column>
            </el-table>
            <div class="action-footer">
                <span>
                    商品金额合计：
                    <span style="color: red">¥{{ getFloat(totalPrice, 2) | formatePrice3}}</span>
                </span>
            </div>
        </el-form>
    </div>
</template>

<script>

import { mapState } from 'vuex';
export default {
    name: 'submitSpcOrder',
    props: {
        Customer_info: {
            type: Object,
            default: () => ({})
        },
        //订单类型: 0销售订单1服务订单
        Orders_Type: {
            type: Number,
            default: 0
        },
        //交易类型:0：正常交易 1报价单2打包订单
        TradeType: {
            type: Number,
            default: 0
        },
        //合同来源: 0报价单1合同变更2独立合同
        Orders_SourceCate: {
            type: Number,
            default: 1
        },

        totalPrice: {
            type: Number,
            default: 0
        },
        submitReturnsList: {
            type: Array,
            default: () => []
        },
        orderInfo: {
            type: Object,
            default: () => ({})
        },
        submitCustomerInfor: {
            type: Object,
            default: () => ({})
        },
        orders_id: {
            type: [String, Number],
            default: ''
        }
    },
    async mounted() {
        let orderRequests = [this.getProjectTypes({ name: 'one', id: 0 }), this.$store.dispatch('fetchLocationData'), this.CheckPreInvoice()];
        await Promise.all(orderRequests);
        await this.GetOrdersOnlyBackData();
        console.log(this.orderInfo);
        this.$emit('mountedEnd');
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtList
        })
    },
    data() {
        return {
            addresssInfo: {},
            params: {
                Orders_Contract_Name: this.orderInfo.Orders.Orders_Contract_Name || '', // 联系人姓名
                Orders_Contract_Mobile: this.orderInfo.Orders.Orders_Contract_Mobile || '', // 联系人手机
                Orders_Contract_Email: this.orderInfo.Orders.Orders_Contract_Email || '', // 联系人邮箱
                Customer_Project_Country: this.orderInfo.Orders.Orders_ProjectCountry || '', // 国家
                Customer_Project_State: this.orderInfo.Orders.Orders_ProjectState || '', // 省
                Customer_Project_City: this.orderInfo.Orders.Orders_ProjectCity || '', // 市
                Customer_Project_County: this.orderInfo.Orders.Orders_ProjectCounty || '', // 区县
                Orders_CreditInvoiceStatus: false, // 是否开具红冲发票
                Orders_ReturnCommitment: false, // 退货承诺
                Show_CreditInvoiceStatus: false // 是否显示红冲发票
            },
            cityListopt: [], //工程城市
            districtListopt: [], //工程区县
            cityListAddress: [], //配送城市
            districtListAddress: [], //配送区县

            ProjectTypesList: [],
            ProjectTypesListTwo: [],
            ProjectTypesListThree: [],

            officeManID: '',
            offinceList: [],
            SupplierList: []
        };
        
    },
    methods: {
        // 是否显示红冲发票
        async CheckPreInvoice() {
            let obj = {
                erp_sn: this.submitCustomerInfor.erp_sn || this.submitCustomerInfor.Orders_ERPSN,
                orders_amount: 0,
                back_amount: this.submitCustomerInfor.back_amount
            };
            let json = JSON.stringify(obj);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.CheckPreInvoice({
                json: json
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                this.params.Show_CreditInvoiceStatus = result.data.data;
            }
        },
        // 获取表单参数
        getFormParams() {
            let data = this.params;
            let result = this.addresssInfo;
            data = {
                ...data,
                ...result
            };
            return data;
        },
        // 仅退货收货地址
        async GetOrdersOnlyBackData() {
            let result = await this.$newsApi.order.GetOrdersOnlyBackData();
            let data = result.data.data;
            this.addresssInfo = data;

            if (this.params.Customer_Project_County == '') {
                this.params.Customer_Project_State = '';
                this.params.Customer_Project_City = '';
            }
        },
        // 修改合同-获取合同详情
        async getSPCOrdersDetails(e) {
            let loadingInstance = this.$loading(); // 显示 loading
            let { data: result } = await this.$newsApi.order.GetSPCOrdersByID({ ID: e });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.Resultcode == 0) {
                // 需要根据省筛选出市列表，根据市筛选出县列表，这样才能回显
                this.cityListopt = this.cityList.filter((item) => item.Statecode == result.data.Orders_ProjectState);
                this.districtListopt = this.districtList.filter((item) => item.citycode == result.data.Orders_ProjectCity);
                // 映射关系
                const mapping = {
                    Orders_Contract_Name: 'Orders_Contract_Name', // 联系人姓名
                    Orders_Contract_Mobile: 'Orders_Contract_Mobile', // 联系人手机
                    Orders_Contract_Email: 'Orders_Contract_Email', // 联系人邮箱
                    Customer_Project_Country: 'Orders_ProjectCountry', // 国家
                    Customer_Project_State: 'Orders_ProjectState', // 省 Orders_ProjectState
                    Customer_Project_City: 'Orders_ProjectCity', // 市
                    Customer_Project_County: 'Orders_ProjectCounty' // 区县
                };
                // 赋值操作
                for (const key in mapping) {
                    if (mapping.hasOwnProperty(key)) {
                        this.params[key] = result.data[mapping[key]];
                    }
                }
                this.params.Orders_CreditInvoiceStatus = result.data.Orders_CreditInvoiceStatus != 1 ? false : true;
                this.params.Orders_ReturnCommitment = !result.data.Orders_IsEvaluate || result.data.Orders_IsEvaluate == -1 ? false : true;
                console.log(this.params.Orders_CreditInvoiceStatus, this.params.Orders_ReturnCommitment);
            }
        },
        // 项目类型联动展示
        async DisplayProjectTypeRecursion(e) {
            let result;
            result = await this.$newsApi.order.DisplayProjectTypeRecursionID({ ID: e });
            // 工程类型
            result.data = result.data.data;
            if (result.data) {
                var typeArr = result.data.split('>');
                await this.getProjectTypes({ name: 'two', id: typeArr[0] });
                if (typeArr.length < 2) return;
                this.params.Orders_ProjectType_ID_Two = typeArr[1] || '';
                if (!typeArr[1]) return;
                await this.getProjectTypes({ name: 'three', id: typeArr[1] });
                this.params.Orders_ProjectType_ID_Three = typeArr[2] || '';
            }
        },
        // 获取地址和项目类型名称
        getNameMethods() {
            let data = this.params;
            let nameInfo = {};
            nameInfo.Customer_Project_Site_Name = this.getAddressName(data.Customer_Project_Country, data.Customer_Project_State, data.Customer_Project_City, data.Customer_Project_County);
            nameInfo.Orders_ProjectType_Name = this.getProjectTypeName(data.Orders_ProjectType_ID, data.Orders_ProjectType_ID_Two, data.Orders_ProjectType_ID_Three);
            nameInfo.Orders_Address_Site_Name = this.getAddressName(data.Orders_Address_Country, data.Orders_Address_State, data.Orders_Address_City, data.Orders_Address_County);
            return nameInfo;
        },
        // 根据工程地址code获取地址名称
        getAddressName(country, state, city, county) {
            let Customer_Project_State_Name = this.provinceList.find((item) => item.Code == state).Name;
            let Customer_Project_City_Name = this.cityList.find((item) => item.Code == city).Name;
            let Customer_Project_County_Name = this.districtList.find((item) => item.Code == county).Name;
            let Customer_Project_Site_Name = Customer_Project_State_Name + Customer_Project_City_Name + Customer_Project_County_Name;
            return Customer_Project_Site_Name;
        },
        // 根据项目类型获取项目类型名称
        getProjectTypeName(id, idTwo, idThree) {
            // 防御性检查：确保数组已加载且不为空
            let Orders_ProjectType_Name = '';
            let Orders_ProjectType_Name_Two = '';
            let Orders_ProjectType_Name_Three = '';
            
            // 一级分类
            if (id && this.ProjectTypesList && this.ProjectTypesList.length > 0) {
                const item = this.ProjectTypesList.find((item) => item.Project_Type_ID == id);
                Orders_ProjectType_Name = item ? item.Project_Type_Name || '' : '';
            }
            
            // 二级分类
            if (idTwo && this.ProjectTypesListTwo && this.ProjectTypesListTwo.length > 0) {
                const item = this.ProjectTypesListTwo.find((item) => item.Project_Type_ID == idTwo);
                Orders_ProjectType_Name_Two = item ? item.Project_Type_Name || '' : '';
            }
            
            // 三级分类
            if (idThree && this.ProjectTypesListThree && this.ProjectTypesListThree.length > 0) {
                const item = this.ProjectTypesListThree.find((item) => item.Project_Type_ID == idThree);
                Orders_ProjectType_Name_Three = item ? item.Project_Type_Name || '' : '';
            }
            
            let Orders_ProjectType_info = Orders_ProjectType_Name + Orders_ProjectType_Name_Two + Orders_ProjectType_Name_Three;
            return Orders_ProjectType_info;
        },
        submitOrder() {
            // Handle order submission logic here
            console.log('Order submitted:', this.orderName, this.orderDetails);
        },
        /*
        选择省-工程
        */
        provinceChange(e) {
            this.cityListopt = [];
            this.params.Customer_Project_City = '';
            this.districtListopt = [];
            this.params.Customer_Project_County = '';
            this.cityListopt = this.cityList.filter((item) => item.Statecode == e);
        },
        /*
        选择市-工程
        */
        cityChange(e) {
            this.districtListopt = [];
            this.params.Customer_Project_County = '';
            this.districtListopt = this.districtList.filter((item) => item.citycode == e);
        },
        countryChange(e, i) {
            this.params.Customer_Project_Country = i;
            this.params.Customer_Project_State = '';
            this.params.Customer_Project_City = '';
            this.params.Customer_Project_County = '';
            this.districtListopt = [];
            this.cityListopt = [];
        },
        /*
        选择省-配送
        */
        provinceChangeAddress(e) {
            this.cityListAddress = [];
            this.params.Orders_Address_City = '';
            this.districtListAddress = [];
            this.params.Orders_Address_County = '';
            this.cityListAddress = this.cityList.filter((item) => item.Statecode == e);
        },
        /*
        选择市-配送
        */
        cityChangeAddress(e) {
            this.districtListAddress = [];
            this.params.Orders_Address_County = '';
            this.districtListAddress = this.districtList.filter((item) => item.citycode == e);
        },
        // 获取项目类型
        async getProjectTypes(e) {
            var result = await this.$newsApi.order.getProjectTypes({
                CateID: e.id
            });
            if (e.name == 'one') {
                this.ProjectTypesList = result.data.data || [];
            } else if (e.name == 'two') {
                this.ProjectTypesListTwo = result.data.data || [];
                if (this.ProjectTypesListTwo.length == 0) {
                    this.params.Orders_ProjectType_ID_Two = '';
                }
            } else if (e.name == 'three') {
                this.ProjectTypesListThree = result.data.data || [];
                if (this.ProjectTypesListThree.length == 0) {
                    this.params.Orders_ProjectType_ID_Three = '';
                }
            }
        },
        // 查询订单联系人信息
        async searchUser() {
            if (this.params.Orders_Contract_Name) {
                var result = await this.GetOrdersContractInfo(this.params.Orders_Contract_Name);
                if (result.data) {
                    this.params.Orders_Contract_Mobile = result.data.Member_Mobile;
                    this.params.Orders_Contract_Email = result.data.Member_Email;
                } else {
                    this.$message.error('未查询到该联系人信息');
                    this.params.Orders_Contract_Mobile = '';
                    this.params.Orders_Contract_Email = '';
                }
            } else {
                this.$message.warning('请输入联系人姓名');
                this.params.Orders_Contract_Mobile = '';
                this.params.Orders_Contract_Email = '';
            }
        },
        async GetOrdersContractInfo(e) {
            var result = await this.$newsApi.order.getOrdersContractInfo({
                CustomerID: this.Customer_info.Customer_ID,
                contract_name: e
            });
            return result.data;
        }
    }
};
</script>

<style scoped lang="scss">
/deep/ .lm-icon{
    margin-right: 10px;
}
.mt0 {
    margin-top: 0 !important;
}

.mt10 {
    margin-top: 10px;
}

.ml10 {
    margin-left: 10px;
}
.mr10 {
    margin-right: 10px;
}
.mb10 {
    margin-bottom: 10px;
}
.tip {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
}

.form-title {
    margin: 40px 0 20px 0;
    font-size: 16px;
    font-weight: 700;
}
.flex {
    display: flex;
    align-items: center;
}
.info {
    // width: 600px;

    .info-title {
        font-size: 16px;
        font-weight: 700;
    }

    .info-list {
        // padding:10px 20px;
    }

    .info-item {
        display: flex;
        margin: 10px 0;
        font-size: 14px;
        color: #000000;

        .label {
            width: 90px;
        }

        .content {
            flex: 1;
            height: auto;
        }
    }

    .label-middle {
        width: 100px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.action-footer {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
}
.action-footer-btn {
    width: 100%;
    text-align: center;
}
</style>
